// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   PRIVACY POLICY MODAL - ACCELLOR BRANDING
   ========================================== */

/* Privacy Policy Modal Overlay */
.privacy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--interview-z-modal);
  padding: var(--interview-space-xl);
  animation: privacy-fadeIn var(--interview-transition-base) ease-out;
  font-family: var(--interview-font-primary);
}

@keyframes privacy-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Container */
.privacy-modal {
  background: var(--interview-bg-white);
  border-radius: var(--interview-radius-2xl);
  max-width: 680px;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: privacy-slideUp var(--interview-transition-slow) ease-out;
}

@keyframes privacy-slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Header */
.privacy-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--interview-space-2xl) var(--interview-space-3xl);
  border-bottom: 1px solid var(--interview-border-default);
}

.privacy-title {
  font-size: 1.5rem;
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0;
  letter-spacing: -0.02em;
}

.privacy-closeButton {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--interview-text-muted);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--interview-radius-sm);
  transition: all var(--interview-transition-base);
  line-height: 1;
}

.privacy-closeButton:hover {
  background: var(--interview-bg-card);
  color: var(--interview-text-primary);
}

/* Content */
.privacy-content {
  flex: 1;
  overflow-y: auto;
  padding: var(--interview-space-3xl);
}

.privacy-section {
  margin-bottom: 28px;
}

.privacy-section:last-child {
  margin-bottom: 0;
}

.privacy-section h3 {
  font-size: 1.125rem;
  font-weight: var(--interview-text-semibold);
  color: var(--interview-text-primary);
  margin: 0 0 var(--interview-space-md) 0;
  letter-spacing: -0.01em;
}

.privacy-section p {
  font-size: var(--interview-text-base);
  line-height: 1.6;
  color: var(--interview-text-secondary);
  margin: 0 0 var(--interview-space-md) 0;
  font-weight: var(--interview-text-regular);
}

.privacy-section p:last-child {
  margin-bottom: 0;
}

.privacy-section ul {
  margin: var(--interview-space-md) 0 0 0;
  padding-left: var(--interview-space-2xl);
}

.privacy-section li {
  font-size: var(--interview-text-base);
  line-height: 1.6;
  color: var(--interview-text-secondary);
  margin-bottom: var(--interview-space-sm);
  font-weight: var(--interview-text-regular);
}

.privacy-section li:last-child {
  margin-bottom: 0;
}

.privacy-lastUpdated {
  font-size: 0.875rem;
  color: var(--interview-text-disabled);
  font-style: italic;
  margin-top: var(--interview-space-sm);
}

/* Footer */
.privacy-footer {
  padding: var(--interview-space-xl) var(--interview-space-3xl);
  border-top: 1px solid var(--interview-border-default);
  display: flex;
  justify-content: flex-end;
}

.privacy-acceptButton {
  background: var(--interview-brand-primary);
  color: var(--interview-bg-white);
  border: none;
  border-radius: var(--interview-radius-md);
  padding: var(--interview-space-md) 28px;
  font-size: var(--interview-text-base);
  font-weight: var(--interview-text-semibold);
  cursor: pointer;
  transition: all var(--interview-transition-base);
  letter-spacing: -0.01em;
  font-family: var(--interview-font-primary);
}

.privacy-acceptButton:hover {
  background: var(--interview-brand-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--interview-shadow-button);
}

.privacy-acceptButton:active {
  transform: translateY(0);
}

/* Scrollbar Styling */
.privacy-content::-webkit-scrollbar {
  width: 8px;
}

.privacy-content::-webkit-scrollbar-track {
  background: var(--interview-bg-card);
  border-radius: var(--interview-radius-sm);
}

.privacy-content::-webkit-scrollbar-thumb {
  background: var(--interview-border-light);
  border-radius: var(--interview-radius-sm);
}

.privacy-content::-webkit-scrollbar-thumb:hover {
  background: var(--interview-text-disabled);
}

/* Responsive */
@media (max-width: 768px) {
  .privacy-overlay {
    padding: 12px;
  }

  .privacy-modal {
    max-height: 90vh;
    border-radius: 12px;
  }

  .privacy-header {
    padding: 20px 24px;
  }

  .privacy-title {
    font-size: 20px;
  }

  .privacy-content {
    padding: 24px;
  }

  .privacy-section h3 {
    font-size: 16px;
  }

  .privacy-section p,
  .privacy-section li {
    font-size: 14px;
  }

  .privacy-footer {
    padding: 16px 24px;
  }

  .privacy-acceptButton {
    width: 100%;
    padding: 14px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/PrivacyPolicyModal/PrivacyPolicyModal.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,mEAAmE;EACnE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,oEAAoE;AACtE;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8DAA8D;EAC9D,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,oCAAoC;EACpC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,OAAO;EACP,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,qDAAqD;EACrD,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;EACvC,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gDAAgD;EAChD,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* ==========================================\n   PRIVACY POLICY MODAL - ACCELLOR BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n/* Privacy Policy Modal Overlay */\n.privacy-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--interview-z-modal);\n  padding: var(--interview-space-xl);\n  animation: privacy-fadeIn var(--interview-transition-base) ease-out;\n  font-family: var(--interview-font-primary);\n}\n\n@keyframes privacy-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Container */\n.privacy-modal {\n  background: var(--interview-bg-white);\n  border-radius: var(--interview-radius-2xl);\n  max-width: 680px;\n  width: 100%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: privacy-slideUp var(--interview-transition-slow) ease-out;\n}\n\n@keyframes privacy-slideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Header */\n.privacy-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--interview-space-2xl) var(--interview-space-3xl);\n  border-bottom: 1px solid var(--interview-border-default);\n}\n\n.privacy-title {\n  font-size: 1.5rem;\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.privacy-closeButton {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: var(--interview-text-muted);\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--interview-radius-sm);\n  transition: all var(--interview-transition-base);\n  line-height: 1;\n}\n\n.privacy-closeButton:hover {\n  background: var(--interview-bg-card);\n  color: var(--interview-text-primary);\n}\n\n/* Content */\n.privacy-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--interview-space-3xl);\n}\n\n.privacy-section {\n  margin-bottom: 28px;\n}\n\n.privacy-section:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-section h3 {\n  font-size: 1.125rem;\n  font-weight: var(--interview-text-semibold);\n  color: var(--interview-text-primary);\n  margin: 0 0 var(--interview-space-md) 0;\n  letter-spacing: -0.01em;\n}\n\n.privacy-section p {\n  font-size: var(--interview-text-base);\n  line-height: 1.6;\n  color: var(--interview-text-secondary);\n  margin: 0 0 var(--interview-space-md) 0;\n  font-weight: var(--interview-text-regular);\n}\n\n.privacy-section p:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-section ul {\n  margin: var(--interview-space-md) 0 0 0;\n  padding-left: var(--interview-space-2xl);\n}\n\n.privacy-section li {\n  font-size: var(--interview-text-base);\n  line-height: 1.6;\n  color: var(--interview-text-secondary);\n  margin-bottom: var(--interview-space-sm);\n  font-weight: var(--interview-text-regular);\n}\n\n.privacy-section li:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-lastUpdated {\n  font-size: 0.875rem;\n  color: var(--interview-text-disabled);\n  font-style: italic;\n  margin-top: var(--interview-space-sm);\n}\n\n/* Footer */\n.privacy-footer {\n  padding: var(--interview-space-xl) var(--interview-space-3xl);\n  border-top: 1px solid var(--interview-border-default);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.privacy-acceptButton {\n  background: var(--interview-brand-primary);\n  color: var(--interview-bg-white);\n  border: none;\n  border-radius: var(--interview-radius-md);\n  padding: var(--interview-space-md) 28px;\n  font-size: var(--interview-text-base);\n  font-weight: var(--interview-text-semibold);\n  cursor: pointer;\n  transition: all var(--interview-transition-base);\n  letter-spacing: -0.01em;\n  font-family: var(--interview-font-primary);\n}\n\n.privacy-acceptButton:hover {\n  background: var(--interview-brand-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--interview-shadow-button);\n}\n\n.privacy-acceptButton:active {\n  transform: translateY(0);\n}\n\n/* Scrollbar Styling */\n.privacy-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.privacy-content::-webkit-scrollbar-track {\n  background: var(--interview-bg-card);\n  border-radius: var(--interview-radius-sm);\n}\n\n.privacy-content::-webkit-scrollbar-thumb {\n  background: var(--interview-border-light);\n  border-radius: var(--interview-radius-sm);\n}\n\n.privacy-content::-webkit-scrollbar-thumb:hover {\n  background: var(--interview-text-disabled);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .privacy-overlay {\n    padding: 12px;\n  }\n\n  .privacy-modal {\n    max-height: 90vh;\n    border-radius: 12px;\n  }\n\n  .privacy-header {\n    padding: 20px 24px;\n  }\n\n  .privacy-title {\n    font-size: 20px;\n  }\n\n  .privacy-content {\n    padding: 24px;\n  }\n\n  .privacy-section h3 {\n    font-size: 16px;\n  }\n\n  .privacy-section p,\n  .privacy-section li {\n    font-size: 14px;\n  }\n\n  .privacy-footer {\n    padding: 16px 24px;\n  }\n\n  .privacy-acceptButton {\n    width: 100%;\n    padding: 14px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
